/* eslint-disable */
// src/components/common/ShareButton.js

import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import { disabledButtonSx } from "components/common/buttonStyles";

export default function ShareButton({ children = "Compartir", sx, ...props }) {
  return (
    <Button
      type="button"
      variant="contained"
      disableElevation
      sx={{
        color: "#fff",
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 1.5,
        px: 2.5,
        // Azul fijo (no depende del theme)
        backgroundColor: "#1976d2",
        "&:hover": { backgroundColor: "#115293" },
        "&:active": { backgroundColor: "#0d3c61" },
        ...disabledButtonSx,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

ShareButton.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
